import axios from 'axios';
import store from '@/store';
import CompetitionSetting from '@/models/competition';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_COMPETITION_URL = process.env.VUE_APP_API_URL + '/competition';
const API_FILE_URL = process.env.VUE_APP_API_URL + "/files";

export default class CompetitionController {
    // Fetch competition setting
    static async fetchCompetitionSetting() {
        const response = await axios.get(`${API_COMPETITION_URL}/get_competition_setting`);
        console.log('Competition setting fetched successfully:', response.data);
        return new CompetitionSetting(response.data);
    }

    // Save competition setting
    static async saveCompetitionSetting(setting) {
        // Prepare payload
        const payload = {
            homeworks: setting.homeworks.map(hw => ({
                id: hw.id,
                in_competition: hw.in_competition,
                deadlines: hw.deadlines && hw.deadlines.length > 0
                    ? hw.deadlines.map(dl => ({ id: dl.id, points: dl.points }))
                    : undefined,
                bonuses: hw.bonuses && hw.bonuses.length > 0
                    ? hw.bonuses.map(b => ({
                        id: b.id,
                        points: b.points,
                        // Optional fields
                        ...(b.title !== undefined ? { title: b.title } : {}),
                        ...(b.prefix !== undefined ? { prefix: b.prefix } : {}),
                        ...(b.metric !== undefined ? { metric: b.metric } : {}),
                        ...(b.top_k !== undefined ? { top_k: b.top_k } : {})
                    }))
                    : undefined
            }))
        };
        const response = await axios.post(`${API_COMPETITION_URL}/update_competition_setting`, payload);
        return new CompetitionSetting(response.data);
    }

    static async generateCompetitionResultsCsv() {
        const semester_id = store.getters.semesterId;
        const response = await axios.post(`${API_COMPETITION_URL}/generate_competition_results_csv/${semester_id}`);
        return response.data;
    }

    static async downloadCompetitionResultsCsv() {
        const semester_id = store.getters.semesterId;
        const response = await axios.get(`${API_FILE_URL}/download_competition_results_csv/${semester_id}`, {
            responseType: 'blob'
        });
        return response;
    }

    // Create a new competition bonus for a homework
    static async createCompetitionBonus(homeworkId, createBonus) {
        const response = await axios.post(
            `${API_COMPETITION_URL}/create_competition_bonus`,
            createBonus,
            { params: { homework_id: homeworkId } }
        );
        return new CompetitionSetting(response.data);
    }

    // Delete a competition bonus from a homework
    static async deleteCompetitionBonus(homeworkId, bonusId) {
        const response = await axios.delete(
            `${API_COMPETITION_URL}/delete_competition_bonus`,
            { params: { homework_id: homeworkId, bonus_id: bonusId } }
        );
        return new CompetitionSetting(response.data);
    }
}

applyErrorHandlers(CompetitionController);
